module.exports = __webpack_public_path__ + "img/shield-virus.9ccc81e6.svg";